export default __webpack_public_path__ + "static/media/Trap-repeat.30eecd95.png";